import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import BookingModal from './BookingModal';
import AuthModals from './AuthModals';
import '../styles/PracticeAreas.css';

const CivilLaw: React.FC = () => {
  const [showLogin, setShowLogin] = useState(false);
  const [showSignup, setShowSignup] = useState(false);
  const [showBooking, setShowBooking] = useState(false);

  return (
    <div className="practice-area-page">
      <Header 
        onOpenLogin={() => setShowLogin(true)}
        onOpenSignup={() => setShowSignup(true)}
      />
      
      <section className="practice-banner">
        <div className="banner-overlay"></div>
        <div className="banner-content">
          <h1 className="banner-title">Civil Law Services</h1>
          <p className="banner-subtitle">
            Expert civil litigation and dispute resolution services with transparent pricing and professional expertise.
          </p>
          <div className="banner-icons">
            <div className="banner-icon">
              <i className="fas fa-gavel"></i>
              <span>Litigation</span>
            </div>
            <div className="banner-icon">
              <i className="fas fa-handshake"></i>
              <span>Resolution</span>
            </div>
            <div className="banner-icon">
              <i className="fas fa-balance-scale"></i>
              <span>Justice</span>
            </div>
          </div>
        </div>
      </section>

      <div className="practice-container">
        <div className="practice-content">
          <section className="overview-section">
            <h2>Civil Law Overview</h2>
            <p>Civil law deals with disputes between individuals, organizations, or between the two, in which compensation is awarded to the victim. Civil law cases are concerned with private rights and remedies.</p>
          </section>

          <section className="services-section">
            <h2>Our Civil Law Services</h2>
            <div className="service-grid">
              <div className="service-item">
                <i className="fas fa-home"></i>
                <h3>Property Disputes</h3>
                <p>Property title verification, boundary disputes, landlord-tenant issues, and property documentation.</p>
              </div>
              <div className="service-item">
                <i className="fas fa-file-contract"></i>
                <h3>Contract Disputes</h3>
                <p>Business contracts, employment agreements, breach of contract cases, and contract drafting.</p>
              </div>
              <div className="service-item">
                <i className="fas fa-money-bill-wave"></i>
                <h3>Recovery Suits</h3>
                <p>Money recovery, debt collection, loan disputes, and financial claim settlements.</p>
              </div>
              <div className="service-item">
                <i className="fas fa-users"></i>
                <h3>Partnership Disputes</h3>
                <p>Business partnership conflicts, profit sharing disputes, and partnership dissolution.</p>
              </div>
            </div>
          </section>

          <section className="process-section">
            <h2>Our Process</h2>
            <div className="process-steps">
              <div className="step">
                <div className="step-number">1</div>
                <h3>Initial Consultation</h3>
                <p>Understand your case details and legal requirements through detailed discussion.</p>
              </div>
              <div className="step">
                <div className="step-number">2</div>
                <h3>Case Analysis</h3>
                <p>Thorough analysis of your case with document review and legal research.</p>
              </div>
              <div className="step">
                <div className="step-number">3</div>
                <h3>Strategy Development</h3>
                <p>Develop a comprehensive legal strategy tailored to your specific situation.</p>
              </div>
              <div className="step">
                <div className="step-number">4</div>
                <h3>Legal Action</h3>
                <p>Execute the legal strategy with court proceedings or settlement negotiations.</p>
              </div>
            </div>
          </section>

          <section className="faq-section">
            <h2>Frequently Asked Questions</h2>
            <div className="faq-grid">
              <div className="faq-item">
                <h3>What is the typical duration of civil cases?</h3>
                <p>Civil cases typically take 6 months to 2 years depending on complexity and court schedules.</p>
              </div>
              <div className="faq-item">
                <h3>What documents do I need for property disputes?</h3>
                <p>Property papers, sale deed, mutation records, tax receipts, and any existing agreements.</p>
              </div>
              <div className="faq-item">
                <h3>Can civil cases be settled out of court?</h3>
                <p>Yes, many civil disputes can be resolved through negotiation, mediation, or arbitration.</p>
              </div>
              <div className="faq-item">
                <h3>What are the costs involved in civil litigation?</h3>
                <p>Costs include court fees, lawyer fees, documentation charges, and stamp duties as applicable.</p>
              </div>
            </div>
          </section>

          <section className="cta-section">
            <div className="cta-card">
              <h2>Need Civil Law Assistance?</h2>
              <p>Get expert legal consultation for your civil law matters. Our experienced lawyers are ready to help.</p>
              <button className="btn btn-primary" onClick={() => setShowBooking(true)}>
                Book Consultation - ₹2000
              </button>
            </div>
          </section>
        </div>
      </div>

      <Footer />
      
      <BookingModal 
        isOpen={showBooking}
        onClose={() => setShowBooking(false)}
      />
      <AuthModals 
        showLogin={showLogin}
        showSignup={showSignup}
        onCloseLogin={() => setShowLogin(false)}
        onCloseSignup={() => setShowSignup(false)}
        onOpenSignup={() => setShowSignup(true)}
        onOpenLogin={() => setShowLogin(true)}
      />
    </div>
  );
};

export default CivilLaw;